/**
 * Contact-field rules shared by every expert form.
 *
 * Mirrors the server-side source of truth in `expert/registration_sync.py`
 * (`PHONE_REGEX` / `PHONE_HTML_PATTERN` + the email validators), so the SPA, the
 * legacy Django forms and the DRF serializers all reject the same input. Applies
 * to the organization and contact phones on the identification step as well as
 * the reference-client phones on a mandate.
 */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Digits and the usual separators, with at least 7 actual digits — the lookahead
// is what stops a run of bare separators ("+++++++") from passing as a number.
const PHONE_RE = /^(?=(?:\D*\d){7,})[\d\s.()+-]{7,20}$/;

export function isValidEmail(value: string) {
  return EMAIL_RE.test(value);
}

/** True when `value` is blank (phones are optional) or a realistic number. */
export function isRealisticPhone(value: string) {
  return value.trim() === "" || PHONE_RE.test(value);
}
